<template>
  <div id="bannerchild" :style="{background:`url(${bodyBackgroundUrl}) no-repeat center`}">
  </div>
</template>
<script>
  export default {
    name: 'bannerView',
    data() {
      return {
        bodyBackgroundUrl: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/banner1000.jpg'
      }
    }
  }
</script>
<style>
  #bannerchild {
    height: 137px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/BannerView.vue